export default "__VITE_ASSET__acc77d95__"